import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sellers/new',
  title: 'title.new',
  endpoint: '/app/person',
  breadcrumbs: [],
}
